module.exports = __webpack_public_path__ + "img/ring_r_l_null_null@3x.ff47cb4d.png";